import {REGEX_CAR_PLATE, REGEX_EMAIL, REGEX_MOBILE_PHONE, REGEX_SPAIN_POSTALCODE} from '../../base.js'
import {
  additionalDataDatalist,
  colourDatalist,
  defaultTabIndex,
  displayTypes,
  environmentalLabelDatalist,
  formFieldContexts,
  formFieldIds,
  inputTypes,
  transmissionsDatalist
} from './values.js'

const {
  comments,
  makeId,
  modelId,
  bodyTypeDoorsId,
  fuelId,
  yearId,
  versionId,
  transmissionTypeId,
  hidePhone,
  kilometersId,
  postalCode,
  price,
  name,
  colour,
  email,
  environmentalLabel,
  notification,
  phone,
  plate,
  plateRegistrationDate,
  recommendedPrice,
  additionalTitle,
  vehicleStatus,
  dataPrivacyCheckbox,
  reliableInfoCheckbox
} = formFieldIds

// CONSTRAINTS GENERATORS

export const getMaxLengthConstraint = ({value}) => ({
  property: {
    maxlength: value
  }
})

export const getNotNullConstraint = ({message}) => ({
  message,
  property: {
    notnull: ''
  }
})

export const getPatternConstraint = ({message, pattern}) => ({
  message,
  property: {
    pattern
  }
})

export const configFields = {
  [additionalTitle]: {
    id: additionalTitle,
    display: displayTypes.block
  },
  [bodyTypeDoorsId]: {
    context: formFieldContexts[bodyTypeDoorsId],
    disabled: true,
    display: displayTypes.dropdownAutosuggest,
    hint: 'COMMON.SELECT_OR_WRITE',
    id: bodyTypeDoorsId,
    label: 'COMMON.PLURALS.BODY_TYPE',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.picker,
    constraints: {
      notNull: {message: 'PUBLISH_AD.FB.BODYTYPES.CONSTRAINTS.NOTNULL'}
    }
  },
  [comments]: {
    display: displayTypes.multiline,
    id: comments,
    label: 'FORM.COMMENTS_LABEL',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.text,
    constraints: {
      maxLength: {value: '3000'},
      notNull: {message: 'FORM.REQUIRED_FIELD_ERROR_TEXT.COMMENTS'}
    }
  },
  [dataPrivacyCheckbox]: {
    display: displayTypes.checkbox,
    id: dataPrivacyCheckbox,
    label: 'FORM.DATA_PRIVACY_CHECKBOX_LABEL',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.picker,
    constraints: {
      notNull: {message: 'FORM.REQUIRED_FIELD_ERROR_TEXT.DATA_PRIVACY_CHECKBOX'}
    }
  },
  [email]: {
    display: displayTypes.email,
    hint: 'FORM.EMAIL_PLACEHOLDER',
    id: email,
    label: 'FORM.EMAIL_LABEL',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.text,
    constraints: {
      maxLength: {value: '80'},
      notNull: {message: 'FORM.REQUIRED_FIELD_ERROR_TEXT.EMAIL'},
      pattern: {message: 'FORM.EMAIL_TEXT_ERROR', pattern: REGEX_EMAIL.source}
    }
  },
  [fuelId]: {
    context: formFieldContexts[fuelId],
    disabled: true,
    display: displayTypes.dropdown,
    hint: 'COMMON.SELECT',
    id: fuelId,
    label: 'COMMON.FUEL',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.picker,
    constraints: {
      notNull: {message: 'PUBLISH_AD.FB.FUELS.CONSTRAINTS.NOTNULL'}
    }
  },
  [kilometersId]: {
    hint: 'PUBLISH_AD.FB.KMS.COCHES.HINT',
    id: kilometersId,
    label: 'COMMON.KMS_VEHICLE',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.text,
    constraints: {
      maxLength: {value: '6'},
      notNull: {message: 'PUBLISH_AD.FB.KMS.CONSTRAINTS.NOTNULL'},
      pattern: {message: 'PUBLISH_AD.FB.KMS.CONSTRAINTS.MIN', pattern: /^[1-9][0-9]{3,}/.source}
    }
  },
  [makeId]: {
    context: formFieldContexts[makeId],
    display: displayTypes.dropdownAutosuggest,
    hint: 'COMMON.SELECT_OR_WRITE',
    id: makeId,
    label: 'COMMON.MAKE',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.picker,
    constraints: {
      notNull: {message: 'PUBLISH_AD.FB.MAKES.CONSTRAINTS.NOTNULL'}
    }
  },
  [modelId]: {
    context: formFieldContexts[modelId],
    disabled: true,
    display: displayTypes.dropdownAutosuggest,
    hint: 'COMMON.SELECT_OR_WRITE',
    id: modelId,
    label: 'COMMON.PLURALS.MODEL',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.picker,
    constraints: {
      notNull: {message: 'PUBLISH_AD.FB.MODELS.CONSTRAINTS.NOTNULL'}
    }
  },
  [name]: {
    hint: 'FORM.CONTACT_NAME_YOUR_NAME_PLACEHOLDER',
    id: name,
    label: 'FORM.CONTACT_NAME_LABEL',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.text,
    constraints: {
      maxLength: {value: '30'},
      notNull: {message: 'FORM.REQUIRED_FIELD_ERROR_TEXT.NAME'}
    }
  },
  [phone]: {
    hint: 'FORM.CONTACT_PHONE_WITH_EXAMPLE_PLACEHOLDER',
    id: phone,
    label: 'COMMON.PHONE',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.text,
    constraints: {
      maxLength: {value: '9'},
      notNull: {message: 'INSTANT_OFFER.LANDING.PHONE_IS_REQUIRED'},
      pattern: {message: 'INSTANT_OFFER.LANDING.PHONE_NOT_VALID', pattern: REGEX_MOBILE_PHONE.source}
    }
  },
  [plate]: {
    hint: 'FORM.PLATE.PLACEHOLDER_EXAMPLE',
    id: plate,
    label: 'COMMON.PLATE',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.text,
    constraints: {
      maxLength: {value: '8'},
      notNull: {message: 'FORM.PLATE.ERROR_IS_MANDATORY'},
      pattern: {message: 'FORM.PLATE.ERROR_NOT_VALID', pattern: REGEX_CAR_PLATE.source}
    }
  },
  [postalCode]: {
    hint: 'PUBLISH_AD.STANDALONE.FORM.POSTAL_CODE.HINT',
    id: postalCode,
    label: 'COMMON.POSTAL_CODE',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.text,
    constraints: {
      maxLength: {value: '5'},
      notNull: {message: 'INSTANT_OFFER.LANDING.POSTAL_CODE_IS_REQUIRED'},
      pattern: {message: 'MODAL_LAST_CALL.VALIDATION_MESSAGES.POSTCODE_INVALID', pattern: REGEX_SPAIN_POSTALCODE.source}
    }
  },
  [reliableInfoCheckbox]: {
    display: displayTypes.checkbox,
    id: reliableInfoCheckbox,
    label: 'FORM.RELIABLE_INFO_CHECKBOX_LABEL',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.picker,
    constraints: {
      notNull: {message: 'FORM.REQUIRED_FIELD_ERROR_TEXT.RELIABLE_INFO_CHECKBOX'}
    }
  },
  [transmissionTypeId]: {
    context: formFieldContexts[transmissionTypeId],
    datalist: transmissionsDatalist,
    display: displayTypes.buttonInline,
    id: transmissionTypeId,
    label: 'COMMON.TRANSMISSION',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.picker,
    constraints: {
      notNull: {message: 'PUBLISH_AD.FB.TRANSMISSIONS.CONSTRAINTS.NOTNULL'}
    }
  },
  [vehicleStatus]: {
    datalist: additionalDataDatalist,
    display: displayTypes.dropdown,
    id: vehicleStatus,
    label: 'PUBLISH_AD.STANDALONE.FORM.ADDITIONAL_STATUS',
    hint: 'COMMON.SELECT',
    tabIndex: defaultTabIndex,
    type: inputTypes.picker
  },
  [versionId]: {
    context: formFieldContexts[versionId],
    disabled: true,
    display: displayTypes.dropdownAutosuggest,
    hint: 'COMMON.SELECT_OR_WRITE',
    id: versionId,
    label: 'COMMON.VERSION',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.picker,
    constraints: {
      notNull: {message: 'PUBLISH_AD.FB.VERSIONS.CONSTRAINTS.NOTNULL'}
    }
  },
  [yearId]: {
    context: formFieldContexts[yearId],
    disabled: true,
    display: displayTypes.dropdown,
    hint: 'COMMON.SELECT',
    id: yearId,
    label: 'COMMON.YEAR',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.picker,
    constraints: {
      notNull: {message: 'PUBLISH_AD.FB.YEARS.CONSTRAINTS.NOTNULL'}
    }
  }
}

export const getConfigFields = {
  [bodyTypeDoorsId]: ({customProps} = {}) => ({
    ...configFields[bodyTypeDoorsId],
    display: displayTypes.dropdownAutosuggest,
    constraints: [
      getNotNullConstraint({
        message: 'PUBLISH_AD.FB.BODYTYPES.CONSTRAINTS.NOTNULL'
      })
    ],
    ...customProps
  }),
  [email]: ({customProps} = {}) => ({
    ...configFields[email],
    hint: '',
    constraints: [
      getMaxLengthConstraint({value: '80'}),
      getNotNullConstraint({message: 'INSTANT_OFFER.LANDING.EMAIL_IS_REQUIRED'}),
      getPatternConstraint({message: 'FORM.EMAIL_TEXT_ERROR', pattern: REGEX_EMAIL.source})
    ],
    ...customProps
  }),
  [colour]: ({customProps} = {}) => ({
    datalist: colourDatalist,
    display: displayTypes.dropdown,
    hint: 'COMMON.SELECT',
    id: colour,
    label: 'PUBLISH_AD.FB.COLORS.LABEL',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.picker,
    constraints: [
      getNotNullConstraint({
        message: 'PUBLISH_AD.FB.COLORS.CONSTRAINTS.NOTNULL'
      })
    ],
    ...customProps
  }),
  [environmentalLabel]: ({customProps} = {}) => ({
    datalist: environmentalLabelDatalist,
    display: displayTypes.dropdown,
    hint: 'COMMON.SELECT',
    id: environmentalLabel,
    label: 'FORM.ENVIRONMENTAL_LABEL.LABEL_OPTIONAL',
    tabIndex: defaultTabIndex,
    type: inputTypes.picker,
    ...customProps
  }),
  [fuelId]: ({customProps} = {}) => ({
    ...configFields[fuelId],
    constraints: [
      getNotNullConstraint({
        message: 'PUBLISH_AD.FB.FUELS.CONSTRAINTS.NOTNULL'
      })
    ],
    ...customProps
  }),
  [hidePhone]: ({customProps} = {}) => ({
    display: displayTypes.switch,
    id: hidePhone,
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.picker,
    ...customProps
  }),
  [kilometersId]: ({customProps} = {}) => ({
    display: displayTypes.numeric,
    hint: 'PUBLISH_AD.FB.KMS.COCHES.HINT',
    id: kilometersId,
    label: 'COMMON.KMS_VEHICLE',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.text,
    constraints: [
      getNotNullConstraint({
        message: 'PUBLISH_AD.FB.KMS.COCHES.CONSTRAINTS.NOTNULL'
      }),
      getMaxLengthConstraint({
        value: 7
      }),
      getPatternConstraint({
        message: 'PUBLISH_AD.FB.KMS.COCHES.CONSTRAINTS.MIN',
        pattern: /^[\d.]{4,}$/.source
      })
    ],
    ...customProps
  }),
  [makeId]: ({customProps} = {}) => ({
    ...configFields[makeId],
    display: displayTypes.dropdownAutosuggest,
    constraints: [
      getNotNullConstraint({
        message: 'PUBLISH_AD.FB.MAKES.CONSTRAINTS.NOTNULL'
      })
    ],
    ...customProps
  }),
  [modelId]: ({customProps} = {}) => ({
    ...configFields[modelId],
    display: displayTypes.dropdownAutosuggest,
    constraints: [
      getNotNullConstraint({
        message: 'PUBLISH_AD.FB.MODELS.CONSTRAINTS.NOTNULL'
      })
    ],
    ...customProps
  }),
  [name]: ({customProps} = {}) => ({
    ...configFields[name],
    hint: '',
    label: 'FORM.CONTACT_NAME_OPTIONAL_LABEL',
    required: false,
    constraints: [getMaxLengthConstraint({value: '30'})],
    ...customProps
  }),
  [notification]: ({customProps} = {}) => ({
    hidden: true,
    id: notification,
    type: inputTypes.text,
    ...customProps
  }),
  [phone]: ({customProps} = {}) => ({
    display: displayTypes.numeric,
    hint: 'FORM.CONTACT_PHONE_WITH_EXAMPLE_PLACEHOLDER',
    id: phone,
    label: 'COMMON.PHONE',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.text,
    constraints: [
      getMaxLengthConstraint({value: '9'}),
      getNotNullConstraint({
        message: 'INSTANT_OFFER.LANDING.PHONE_IS_REQUIRED'
      }),
      getPatternConstraint({
        message: 'INSTANT_OFFER.LANDING.PHONE_NOT_VALID',
        pattern: REGEX_MOBILE_PHONE.source
      })
    ],
    ...customProps
  }),
  [plate]: ({customProps} = {}) => ({
    hint: 'FORM.PLATE.PLACEHOLDER_EXAMPLE',
    id: plate,
    label: 'COMMON.PLATE',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.text,
    constraints: [
      getMaxLengthConstraint({value: '8'}),
      getNotNullConstraint({
        message: 'PUBLISH_AD.FB.PLATE.COCHES.CONSTRAINTS.NOTNULL'
      }),
      getPatternConstraint({
        message: 'FORM.PLATE.ERROR_NOT_VALID',
        pattern: REGEX_CAR_PLATE.source
      })
    ],
    ...customProps
  }),
  [plateRegistrationDate]: ({customProps} = {}) => ({
    hidden: true,
    id: plateRegistrationDate,
    type: inputTypes.text,
    ...customProps
  }),
  [postalCode]: ({customProps} = {}) => ({
    display: displayTypes.numeric,
    hint: 'PUBLISH_AD.STANDALONE.FORM.POSTAL_CODE.HINT',
    id: postalCode,
    label: 'COMMON.POSTAL_CODE',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.text,
    constraints: [
      getMaxLengthConstraint({value: 5}),
      getNotNullConstraint({message: 'INSTANT_OFFER.LANDING.POSTAL_CODE_IS_REQUIRED'}),
      getPatternConstraint({
        message: 'MODAL_LAST_CALL.VALIDATION_MESSAGES.POSTCODE_INVALID',
        pattern: REGEX_SPAIN_POSTALCODE.source
      })
    ],
    ...customProps
  }),
  [price]: ({customProps} = {}) => ({
    display: displayTypes.money,
    hint: 'PUBLISH_AD.FB.PRIZES.COCHES.HINT',
    id: price,
    label: 'COMMON.PRICE',
    required: true,
    tabIndex: defaultTabIndex,
    type: inputTypes.text,
    constraints: [
      getNotNullConstraint({
        message: 'PUBLISH_AD.FB.PRIZES.CONSTRAINTS.NOTNULL'
      }),
      getPatternConstraint({
        message: 'PUBLISH_AD.FB.PRIZES.CONSTRAINTS.PATTERN',
        pattern: /^[\d.]{3,}$/.source
      }),
      getMaxLengthConstraint({value: 11})
    ],
    ...customProps
  }),
  [recommendedPrice]: ({customProps} = {}) => ({
    hidden: true,
    id: recommendedPrice,
    type: inputTypes.numeric,
    ...customProps
  }),
  [transmissionTypeId]: ({customProps} = {}) => ({
    ...configFields[transmissionTypeId],
    constraints: [
      getNotNullConstraint({
        message: 'PUBLISH_AD.FB.TRANSMISSIONS.CONSTRAINTS.NOTNULL'
      })
    ],
    ...customProps
  }),
  [additionalTitle]: ({customProps} = {}) => ({
    id: additionalTitle,
    type: 'numeric',
    display: 'block',
    label: '',
    value: 'additional Title',
    ...customProps
  }),
  [vehicleStatus]: ({customProps} = {}) => ({
    datalist: additionalDataDatalist,
    display: displayTypes.dropdown,
    id: vehicleStatus,
    label: 'PUBLISH_AD.STANDALONE.FORM.ADDITIONAL_STATUS',
    hint: 'COMMON.SELECT',
    tabIndex: defaultTabIndex,
    type: inputTypes.picker,
    ...customProps
  }),
  [versionId]: ({customProps} = {}) => ({
    ...configFields[versionId],
    display: displayTypes.dropdownAutosuggest,
    constraints: [
      getNotNullConstraint({
        message: 'PUBLISH_AD.FB.VERSIONS.CONSTRAINTS.NOTNULL'
      })
    ],
    ...customProps
  }),
  [yearId]: ({customProps} = {}) => ({
    ...configFields[yearId],
    label: 'COMMON.REGISTRATION_YEAR',
    constraints: [
      getNotNullConstraint({
        message: 'PUBLISH_AD.FB.YEARS.CONSTRAINTS.NOTNULL'
      })
    ],
    ...customProps
  })
}

// COMMON CONFIGURATION RULES

const operators = {
  exists: 'EXISTS'
}

export const getEmptyFieldRule = ({id, remote = false}) => ({
  when: [{operator: operators.exists, id}],
  then: {
    data: {
      disabled: true,
      required: true,
      datalist: [],
      value: ''
    },
    remote
  }
})

export const getRemoteFieldRule = ({id}) => getEmptyFieldRule({id, remote: true})
